import { useContext } from 'react'
import ConfirmationContext from '../contexts/ConfirmationContext'

const useConfirmationDialog = () => useContext(ConfirmationContext)

export default useConfirmationDialog
